// import { useMemo } from "react";
import { CurrencyInputNumber } from "./CurrencyInputNumber";
import { Form, type FormItemProps, type InputNumberProps } from "antd";
import { currencyInputNumberProps } from "./currencyInput";

type CurrencyFormItemProps = Omit<FormItemProps, "children"> & {
    /** Props for the underlying CurrencyInputNumber */
    inputProps?: InputNumberProps<number>;
};

export const CurrencyFormItem: React.FC<CurrencyFormItemProps> = ({ inputProps, ...itemProps }) => (
    <Form.Item name="amount" label="Amount" required {...itemProps}>
        <CurrencyInputNumber {...currencyInputNumberProps} {...inputProps} />
    </Form.Item>
);
